import { Package } from "@phosphor-icons/react";
import { PickerItemProps } from "../../types";

interface AssetData {
  id: string;
  name: string;
  assetCategory?: {
    name: string;
  };
  building?: {
    resourceId: string;
  };
  unit?: {
    resourceId: string;
  };
}

export const AssetItem = ({ item, isSelected, onSelect }: PickerItemProps<AssetData>) => {
  return (
    <button
      onClick={() => onSelect(item)}
      className={`w-full text-left px-4 py-3 rounded-lg text-sm transition-all duration-200 border ${
        isSelected
          ? "bg-moss-primary/10 border-moss-primary/40 ring-2 ring-moss-primary/20 shadow-sm"
          : "border-neutral-primary/10 hover:border-neutral-primary/20 hover:bg-neutral-primary/5 hover:shadow-sm"
      }`}
    >
      <div className="flex items-center gap-3">
        <div className="flex-shrink-0 w-9 h-9 rounded-lg bg-neutral-primary/5 flex items-center justify-center">
          <Package className="h-5 w-5 text-neutral-primary/70" weight="duotone" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-semibold text-neutral-primary">{item.name}</div>
          <div className="flex items-center gap-2 text-xs text-neutral-secondaryMid mt-0.5">
            {item.assetCategory?.name && (
              <span className="truncate">{item.assetCategory.name}</span>
            )}
            {(item.building || item.unit) && (
              <span className="text-neutral-secondaryLight">•</span>
            )}
            {item.building?.resourceId && (
              <span className="truncate">{item.building.resourceId}</span>
            )}
            {item.unit?.resourceId && (
              <span className="truncate">/ {item.unit.resourceId}</span>
            )}
          </div>
        </div>
      </div>
    </button>
  );
};
